import { useFilterTimeMetric } from 'clientState/hooks/metrics';
import { useCallback } from 'react';

export const useAddStartFilterMetric = () => {
  const { start } = useFilterTimeMetric();
  return useCallback(
    (action) =>
      (...props) => {
        start();
        action(...props);
      },
    [start]
  );
};
